"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDependentFilters = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const filterTypeMap = {
    [app_1.FilterTypeEnum.MultiSelect]: 'refinementList',
    [app_1.FilterTypeEnum.SingleSelect]: 'menu',
};
const isMasterFilterActive = (masterFilter, indexUiState) => {
    var _a;
    const stateKey = filterTypeMap[masterFilter.type];
    return !!((_a = indexUiState === null || indexUiState === void 0 ? void 0 : indexUiState[stateKey]) === null || _a === void 0 ? void 0 : _a[masterFilter.key]);
};
const useDependentFilters = (filters) => {
    const { indexUiState } = (0, react_instantsearch_1.useInstantSearch)();
    const previousMasterStateRef = React.useRef({});
    const masterFilterMap = React.useMemo(() => {
        if (!filters)
            return new Map();
        return filters.reduce((map, filter) => {
            if (filter.dependentOn) {
                const master = filters.find(f => f.key === filter.dependentOn);
                if (master)
                    map.set(filter.key, master);
            }
            return map;
        }, new Map());
    }, [filters]);
    React.useEffect(() => {
        var _a;
        if (!filters)
            return;
        for (const filter of filters) {
            const masterFilter = masterFilterMap.get(filter.key);
            if (!masterFilter)
                continue;
            const wasMasterActive = (_a = previousMasterStateRef.current[masterFilter.key]) !== null && _a !== void 0 ? _a : false;
            const isMasterActive = isMasterFilterActive(masterFilter, indexUiState);
            if (wasMasterActive && !isMasterActive && filter.clearRefinements) {
                filter.clearRefinements();
            }
            previousMasterStateRef.current[masterFilter.key] = isMasterActive;
        }
    }, [filters, indexUiState, masterFilterMap]);
    return React.useMemo(() => {
        if (!filters) {
            return [];
        }
        return filters.map(filter => {
            var _a;
            const masterFilter = masterFilterMap.get(filter.key);
            if (!masterFilter) {
                return filter;
            }
            const hasSelectedOptions = !!((_a = filter.items) === null || _a === void 0 ? void 0 : _a.some(i => i.selected));
            const isVisibleByParent = isMasterFilterActive(masterFilter, indexUiState);
            const isVisible = isVisibleByParent || hasSelectedOptions;
            return Object.assign(Object.assign({}, filter), { isHidden: !isVisible });
        });
    }, [filters, indexUiState, masterFilterMap]);
};
exports.useDependentFilters = useDependentFilters;
